import { MantineDataTable,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import { Stack } from '@mantine/core';
import { useAllMessages } from '../hooks/useAllMessages';
import { useMessagesTableColumns } from '../hooks/useMessagesTableColumns';
import { useRef } from 'react';

export const MessagesTable = () => {
    const { visibleItems, loading, nextToken, fetchRecords, isFetchingNextPage, visibleCount } = useAllMessages();
    const columns = useMessagesTableColumns();
    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack gap="lg">
            <MantineDataTable
                columns={columns}
                records={visibleItems}
                fetching={loading}
                withTableBorder={true}
                onScrollToBottom={fetchRecords}
                scrollViewportRef={scrollViewportRef}
            />
            <DataTableTokenPagination
                loadedCount={visibleCount}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                isFetchingMore={isFetchingNextPage}
            />
        </Stack>
    );
};
